import { TICKETS_NEEDED_FOR_BONUS } from '../../../model/web3Raffle/bonus';

export const SpecialOfferBanner = () => {
  return (
    <div
      className="
      p-4 border-2 card-boxshadow-default border-base-border-pink-medium rounded-2xl"
      style={{ background: 'linear-gradient(180deg, #FEF6FA 0%, #FFF 100%)' }}
    >
      <span className="text-caption-sm-strong-a text-base-text-pink ">Special Offer:&nbsp;</span>
      <span className="text-caption-sm-a text-base-text-primary">
        Receive 1 bonus ticket for every {TICKETS_NEEDED_FOR_BONUS} tickets you buy!
      </span>
    </div>
  );
};
